import { render } from "./card-section.vue?vue&type=template&id=220dd5bf"
import script from "./schools-cardsection.js?vue&type=script&lang=js"
export * from "./schools-cardsection.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__